import type HttpClientInterface from '~/modules/httpClient/HttpClientInterface'
import type {
  DoctorSpeciality,
  DoctorSpecialityCheckResultDTO,
  DoctorSpecialityCheckResult,
  DoctorBabyblogArticleDTO,
  DoctorBabyblogArticle
} from '~/domains/doctor/Doctor.types'
import { normalizeDoctorSpecialityCheckResult, normalizeDoctorBabyblogArticle } from '~/domains/doctor/DoctorProfile'
import { IocContainer } from '~/dependecyInjection/inversify.config'
import { TYPES } from '~/dependecyInjection/types'
import type { IResponse } from '~/types/interfaces/Http'

export function useDoctorRepository () {
  const HttpClient = IocContainer.get<HttpClientInterface>(TYPES.HttpClient)

  const getSpecialities = async (): Promise<DoctorSpeciality[]> => {
    const { return: result } = await HttpClient.post<IResponse<unknown>>('api-main/doctor/getSpecialities')

    if (typeof result !== 'object' || !result) {
      return []
    }

    return Object.entries(result)
      .map(item => ({
        id: typeof item[0] === 'string' ? item[0] : '',
        name: typeof item[1] === 'string' ? item[1] : ''
      }))
      .sort((a, b) => {
        if (a.name.toLowerCase().includes('не знаю')) {
          return 1
        }

        if (b.name.toLowerCase().includes('не знаю')) {
          return -1
        }

        return a.name > b.name ? 1 : -1
      })
  }

  const getSpecialityByText = async (text: string): Promise<DoctorSpecialityCheckResult> => {
    const { return: result } = await HttpClient.post<IResponse<DoctorSpecialityCheckResultDTO>>('api-main/doctor/getSpecialityByText', {
      text
    })

    return normalizeDoctorSpecialityCheckResult(result)
  }

  const getArticlesByDoctor = async (doctorId: string | undefined, page = 0): Promise<DoctorBabyblogArticle[]> => {
    const { return: result } = await HttpClient.post<IResponse<DoctorBabyblogArticleDTO[]>>(
      process.env.API_NODE_URL_BASE + '/api-main/article/getArticlesByDoctor',
      { 'doctor_id': doctorId, page, 'per_page': 10 }
    )

    return Array.isArray(result) ? result.map(normalizeDoctorBabyblogArticle) : []
  }

  return {
    getSpecialities,
    getSpecialityByText,
    getArticlesByDoctor
  }
}
